import { render, staticRenderFns } from "./addproductImageList.vue?vue&type=template&id=2b6e5e56&scoped=true&"
import script from "./addproductImageList.vue?vue&type=script&lang=js&"
export * from "./addproductImageList.vue?vue&type=script&lang=js&"
import style0 from "./addproductImageList.vue?vue&type=style&index=0&id=2b6e5e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e5e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6e5e56')) {
      api.createRecord('2b6e5e56', component.options)
    } else {
      api.reload('2b6e5e56', component.options)
    }
    module.hot.accept("./addproductImageList.vue?vue&type=template&id=2b6e5e56&scoped=true&", function () {
      api.rerender('2b6e5e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addproductImageList.vue"
export default component.exports